



var fullSiteRoot = 'https://hufworldwide.co.uk';

// environment

hufConfig.fullSiteRoot = fullSiteRoot;

hufConfig.shopBaseURL = fullSiteRoot;


// general

hufConfig.colorOptionName = 'Colour';

hufConfig.siteRegion = 'uk';
hufConfig.currencyISO = 'GBP';


// add to cart messages

hufConfig.qtyLowMessage = 'Only a few left, order quick!';
hufConfig.qtyLastMessage = 'Only one left, order quick!';
hufConfig.qtyLimitMessage = 'You have reached the quantity limit for this product.';


// geo

hufConfig.geoDataURL = fullSiteRoot + '/browsing_context_suggestions.json';


// algolia

hufConfig.algoliaAppId = 'MRZ2XS1TIK';
hufConfig.algoliaAPIKey = '24cbc29e1422b13cb64ad6ef3f75e184';

hufConfig.algoliaProductsIndex = 'hufuk_shopify_products';
hufConfig.algoliaProductsSortingIndexes = [
  ['Featured', hufConfig.algoliaProductsIndex],
  ['Price: High to Low', 'hufuk_shopify_products_high-to-low'],
  ['Price: Low to High', 'hufuk_shopify_products_low-to-high']
];
//hufConfig.algoliaCollectionsIndex = 'huf_shopify_collections';
//hufConfig.algoliaPagesIndex = 'huf_shopify_pages';
//hufConfig.algoliaArticlesIndex = 'huf_shopify_articles';

hufConfig.noSearchResultsMessage = 'Sorry, no matches found.';

hufConfig.separateListingProductsByColorTag = 'Separate Colors';


// klaviyo

hufConfig.klaviyoSiteId = 'WQdpBd';
hufConfig.klaviyoListId = 'QRtswf';


// payments

hufConfig.paymentOptionService = 'none';


// sold out notify

hufConfig.notifyEmailEnabled = false;
//hufConfig.notifyPhoneEnabled = true;
//hufConfig.notifyDefaultMethod = 'phone';


// cart

hufConfig.cartAjaxEnabled = true;

hufConfig.fakeCartAjax = false;
hufConfig.cartDataBaseURL = fullSiteRoot;

hufConfig.miniCartCheckoutURL = fullSiteRoot + '/checkout';
hufConfig.miniCartViewCartURL = fullSiteRoot + '/cart';


// urls

hufConfig.collectionURL = fullSiteRoot + '/collections/{collection_slug}';
hufConfig.collectionProductURL = fullSiteRoot + '/collections/{collection_slug}/products/{product_slug}';
hufConfig.productURL = fullSiteRoot + '/products/{product_slug}';
hufConfig.pageURL = fullSiteRoot + '/pages/{page_slug}';
hufConfig.articleURL = fullSiteRoot + '/blogs/{blog_slug}/{article_slug}';

// store locator map

hufConfig.mapStyles = ( // generate using https://snazzymaps.com/editor
  [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#e1e1e1"
              },
              {
                  "visibility": "on"
              }
          ]
      }
  ]
);